export const MICROSITE_PATH = {
  INDEX: '/microsite/satisfaction-survey/',
  EDIT: '/microsite-admin/'
}

export const QUESTIONNAIRE_IMAGE_ACCEPT_FILE_TYPE = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/jpg'
]

export const QUESTIONNAIRE_IMAGE_ACCEPT_FILE_SIZE = 5 * 1024 * 1024 // 5MB

export const SATISFACTION_SURVEY_DEFAULT_QUESTIONNAIRE_TYPE = [
  {
    i18nKey: 'admin.company.satisfactionSurvey.questionnaireType.general',
    value: 'GENERAL'
  }
]

export const SATISFACTION_SURVEY_HM_QUESTIONNAIRE_TYPE = [
  {
    i18nKey: 'admin.company.satisfactionSurvey.questionnaireType.hmScore',
    value: 'HM_SCORE'
  }
]

export const SATISFACTION_SURVEY_CANDIDATE_QUESTIONNAIRE_TYPE = [
  {
    i18nKey: 'admin.company.satisfactionSurvey.questionnaireType.candidateApply',
    value: 'CANDIDATE_APPLY'
  }
]

export const SATISFACTION_SURVEY_HM_INTERVIEW_QUESTIONNAIRE_TYPE =
{
  i18nKey: 'admin.company.satisfactionSurvey.questionnaireType.hmInterview',
  value: 'HM_INTERVIEW'
}

export const SATISFACTION_SURVEY_CANDIDATE_INTERVIEW_QUESTIONNAIRE_TYPE =
{
  i18nKey: 'admin.company.satisfactionSurvey.questionnaireType.candidateInterview',
  value: 'CANDIDATE_INTERVIEW'
}
